import { W as WuiCodeSnippet$1, d as defineCustomElement$1 } from './p-HrxfNVRi.js';

const WuiCodeSnippet = WuiCodeSnippet$1;
const defineCustomElement = defineCustomElement$1;

export { WuiCodeSnippet, defineCustomElement };
